<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   

		<CRow>
			<CCol md="12">
				<CDataTable
					:items="historicData"
					:fields="['N°', 'Fecha', 'Usuario', 'Estado', 'Detalles','Acciones']"
					:items-per-page="10"
					hover
					bordered
					small
					responsive
					class="mt-3"
					:no-sorting="true"
					:sorter="false"
				>
					<template #N°="{ index }">
						<td style="font-size: 10px;">
						{{ index + 1 }}
						</td>                
					</template>
					<template #Fecha="{ item }">
						<td style="font-size: 10px;">
						{{ item.date || '-' }}
						</td>
						
					</template>
					<template #Usuario="{ item }">
						<td style="font-size: 10px;">
						{{ item.user_name || '-' }}
						</td>                
					</template>
					<template #Estado="{ item }">
						<td style="font-size: 10px;">
						{{ item.status }}
						</td>                
					</template>
					<template #Detalles="{ item }">
						<td style="font-size: 10px;">
						{{ item.details || '-' }}
						</td>
					</template>
					<template #Acciones="{ item }">
						<td style="font-size: 10px;">
							<CButton @click="openDeleteRecordsConfirm(item)" color="danger" size="sm">Eliminar Registros</CButton>
						</td>
					</template>
				</CDataTable>					
			</CCol>
		</CRow>	

        <template #footer>
        	<CButton @click="closeModal" color="secondary">Cerrar</CButton>
        </template>
		<ConfirmModal ref="deleteModal" @confirm="deleteRecords" />
    </CModal>	
</template>

<script>

import ws from '../../services/importHistoric';
import store from '../../store'
import ConfirmModal from '../global/ConfirmModal.vue'

export default {
	name: 'ImportHistoricModal',
	props: {		
	},
	components: { ConfirmModal },
	data () {
		return {
			showModal: false,
			title: "Historico de Importaciónes",
			color: "dark",
			historicData: [],
			idToDelete: 0
		}
	},
	mounted: async function() {		
	},
	methods: {
		openModal (challenge_id = 0) {
			this.showModal = true;
			this.color = "dark";
			this.title = 'Historico de Importaciónes';
			this.loadHistoricData();
		},
		openDeleteRecordsConfirm (item) {
			this.idToDelete = item.id;
			this.$refs.deleteModal.show("dark", "Eliminar Registros Importados",
				"Esta acción eliminará todos los registros realizados en esta importación. ¿Deseas continuar?",
			item.date +	"-" + item.user_name);
		},
		async loadHistoricData () {
			this.loading();
				let response = await ws.getIndex({type: 'sales'});

				if(response.type == "success"){
					this.historicData = response.data;
				}else{
					this.showToast(response.type, response.message);
				}
			this.loaded();
		},
		async deleteRecords () {
			this.loading();
				let response = await ws.delete({id: this.idToDelete});

				if(response.type == "success"){
					this.historicData = response.data;
					this.$emit("reload");
				}else{
					this.showToast(response.type, response.message);
				}
			this.loaded();
			this.idToDelete = 0;
		},
		closeModal () {
			this.showModal = false;
			this.historicData = [];
			this.idToDelete = 0;
		},
		showToast(type, message){
			store.commit('toast', {color: type, message: message});
		},
		loading(){
			store.commit('loading');
		},
		loaded(){
			store.commit('loaded');
		}
	},
	computed: {
  	},
}
</script>